import React, { Suspense, lazy } from 'react';
import { Switch, Route, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import PermissionGuard2 from '../../../../Layout/PermissionGuard2';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Lazy load components
const DownloadReports = lazy(() => import('../Pages/DownloadReports'));
const BestSellerReport = lazy(() => import('../Pages/BestSellerReport'));
const DayWiseSaleReport = lazy(() => import('../Pages/DayWiseSaleReport'));
const CategoryReport = lazy(() => import('../Pages/CategoryReport'));
const StockQuantityAlert = lazy(() => import('../Pages/StockQuantityAlert'));
const StoreStockChart = lazy(() => import('../Pages/StoreStockChart'));
const ProductAuditHistory = lazy(() => import('../Pages/ProductAuditHistory'));
const ProductAuditTrail = lazy(() => import('../Pages/ProductAuditTrail'));
const ChangeInTransactionReport = lazy(() => import('../Pages/ChangeInTransactionReport'));
const NightAuditReport = lazy(() => import('../Pages/NightAuditReport'));
const LoginActivity = lazy(() => import('../../LoginActivity/LoginActivity'));
const PmsSyncReport = lazy(() => import('../Pages/PmsSyncReport'));
const SupplierLedger = lazy(() => import('../../Transaction/Pages/SupplierLedger'));
// console.log('LoginActivity',LoginActivity);
// Loading component for Suspense fallback
const Loading = () => (
    <LoadingOverlay
        active={false}
        spinner={<FadeLoader color={"#36D7B7"} />}
        text="Loading..."
        styles={{
            overlay: (base) => ({
                ...base,
                background: "rgba(255, 255, 255, 0.8)",
            }),
            content: (base) => ({
                ...base,
                color: "#36D7B7",
            }),
        }}
    >
        <div style={{ height: "100vh" }}></div>
    </LoadingOverlay>
);

function ReportsRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/reports/download"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <DownloadReports history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/best-seller"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <BestSellerReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/day-wise-sale"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <DayWiseSaleReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/category"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <CategoryReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/stock-alert"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <StockQuantityAlert history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/store-stock-chart"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <StoreStockChart history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/product-audit-history"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <ProductAuditHistory history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/product-audit-trail"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <ProductAuditTrail history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/change-in-transaction"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <ChangeInTransactionReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/night-audit-report"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <NightAuditReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />

            <Route
                exact
                path="/:lng/reports/login-activities"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <LoginActivity history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/pms-sync-report"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <PmsSyncReport history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
            <Route
                exact
                path="/:lng/reports/supplier-ledger"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <SupplierLedger history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
}

export default withNamespaces()(ReportsRoute);
